import React, { useState, useEffect } from "react";
import Layout from "../../components/global/AuthLayout";
import FormControl from "../../components/common/FormControl";
import ApiClient from "../../methods/api/apiClient";
import loader from "../../methods/loader";
import { Tooltip } from "antd";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { useSelector } from "react-redux";
import ImageUpload from "../../components/common/ImageUpload";
import LargeVideoPreview from "../../components/common/LargeVideoPreview";
import { FiPlus } from "react-icons/fi";
import { MdDragIndicator } from "react-icons/md";
import {
  DndContext,
  closestCenter,
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import {
  arrayMove,
  SortableContext,
  sortableKeyboardCoordinates,
  useSortable,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

const MAX_VIDEO_SIZE_BYTES = 5 * 1024 * 1024 * 1024;

const LivePageSettings = () => {
  const navigate = useNavigate();
  const user = useSelector((state) => state.user);



  const isAllow = (key = "") => {
    if (user?.role?.name === "Admin") return true;
    return Boolean(user?.permissions?.[0]?.[key]);
  };

  /** Initial empty form for Reset */
  const initialForm = {
    button: "",
    isLive: false,
    title: "Watch Our Latest Craft Live!",
    subtitle: "Join us every month for a brand-new live craft session! Learn step-by-step with our creative team, ask questions in real time, and craft along using this month’s box.",
    headerText: "",
    embedCode: "",
    selectedShortVideos: [],
    selectedLiveSessions: [],
    headerLink: '',
    nextEvent: false,
    nextEventTitle: '',
    nextEventSubTitle: '',
    nextEventurl: '',
    image: '',
    thumbnail: '',
    isThumbnailLive: false,
    video: '',
    guideTv: false,
  };

  const [submitted, setSubmitted] = useState(false);
  const [shortVideos, setShortVideos] = useState([]);
  const [liveSessions, setLiveSessions] = useState([]);
  const [progress, setProgress] = useState(0);
  const [isGuideTV, setIsGuideTV] = useState(false);
  const [form, setForm] = useState(initialForm);

  // Drag and drop sensors
  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    })
  );

  /** Get Short Videos */
  const getShortVideos = () => {
    ApiClient.get(
      "groovevideo/list?page=1&count=1000&search=&isPublish=published&type=short"
    ).then((res) => {
      if (res.success) {
        const data = res.data.map((v) => ({ id: v.id, name: v.title }));
        setShortVideos(data);
      }
    });
  };

  /** Get Live Sessions */
  const getLiveSessions = () => {
    ApiClient.get(
      "groovevideo/list?page=1&count=1000&search=&isPublish=published&type=long"
    ).then((res) => {
      if (res.success) {
        const data = res.data.map((v) => ({ id: v.id, name: v.title }));
        setLiveSessions(data);
      }
    });
  };

  useEffect(() => {
    getShortVideos();
    getLiveSessions();
  }, []);

  /** Validation */
  const validate = () => {
    if (!form.isLive) return false;
    if (!form.title || !form.subtitle || !form.headerText)
      return true;
    return false;
  };

  /** Submit Handler */
  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);

    if (validate()) return;

    loader(true);
    let payload = { ...form }
    delete payload['_id']
    delete payload['_v']
    delete payload['createdAt']
    delete payload['updatedAt']
    if (!isGuideTV) {
      payload.guideTv = false;
    }
    console.log(payload, "payload");
    ApiClient.post("golive-page/add-update", payload).then((res) => {
      loader(false);
      if (res.success) Swal.fire({ text: 'Saved Successfully!', icon: 'success' })
    });
  };

  /** Handle drag end for Live Sessions */
  const handleDragEnd = (event) => {
    const { active, over } = event;

    if (active.id !== over.id) {
      setForm((prevForm) => {
        const oldIndex = prevForm.selectedLiveSessions.indexOf(active.id);
        const newIndex = prevForm.selectedLiveSessions.indexOf(over.id);
        const newOrder = arrayMove(prevForm.selectedLiveSessions, oldIndex, newIndex);

        return {
          ...prevForm,
          selectedLiveSessions: newOrder,
        };
      });
    }
  };

  /** Get Saved Settings From API */
  const GetSavedSettings = () => {
    loader(true);
    ApiClient.get(`golive-page/detail`).then((res) => {
      if (res.success && res?.data) {
        const data = res?.data;
        data['selectedLiveSessions'] = res?.data?.selectedLiveSessions?.map((_itm) => (_itm?._id || _itm?.id))
        data['selectedShortVideos'] = res?.data?.selectedShortVideos?.map((_itm) => (_itm?._id || _itm?.id))
        console.log(data, "Data is here ----")
        setForm({ ...data });
      }
      loader(false);
    });
  };
  useEffect(() => {
    GetSavedSettings();
  }, []);

  /** RESET FORM HANDLER */
  const handleReset = () => {
    setSubmitted(false);
    setForm(initialForm); // resets to blank form
  };


  const imageResult = (e, key) => {
    setForm((pre) => ({
      ...pre, [key]: e.value
    }))
  };

  /** Upload Video */
  const uploadVideo = async (e) => {
    const files = e.target.files;
    if (!files?.length) return;

    if (files[0]?.size > MAX_VIDEO_SIZE_BYTES) {
      await Swal.fire({
        title: "Video too large",
        text: "Video size must be 5 GB or less.",
        icon: "error",
        confirmButtonText: "OK",
      });
      e.target.value = "";
      return;
    }

    ApiClient.multiImageUpload("upload/big/video", files, {}, "file", setProgress).then(
      (res) => {
        if (res.success) {
          setProgress(0);
          setForm((previous) => ({ ...previous, video: res?.filePath }));
        }
      }
    );
  };

  // console.log("jjjjjjjjj", form);


  return (
    <Layout>
      <form onSubmit={handleSubmit}>
        <div className="shadow-box w-full bg-white rounded-lg mb-4 p-6">

          {/* Header */}
          <div className="flex items-center mb-8">
            <Tooltip placement="top" title="Back">
              <Link
                to="/dashboard"
                className="!px-4 py-2 flex items-center justify-center rounded-lg shadow-btn hover:bg-[#F3F2F5] border transition-all mr-3"
              >
                <i className="fa fa-angle-left text-lg"></i>
              </Link>
            </Tooltip>

            <h3 className="text-lg lg:text-lg sm:text-xl md:text-2xl font-semibold text-[#111827]">
              Live Page Settings
            </h3>
          </div>

          {/* Section */}
          <div className="shadow-box w-full bg-white rounded-lg p-6">
            <div className="flex items-center justify-between gap-2 mb-4 border-b pb-3 border-gray-200">
              <p className="text-xl font-semibold">Live Page</p>

              {/* Toggle */}
              <div className="flex items-center gap-2">
                <span className="text-sm">Go Live?</span>
                <label className="inline-flex items-center cursor-pointer ">
                  <input
                    type="checkbox"
                    checked={form.isLive}
                    className="sr-only peer"
                    onChange={(e) => {
                      setForm({ ...form, isLive: e.target.checked });
                    }}
                    disabled={!isAllow(`addLiveSettings`)}
                  />
                  <div
                    className="relative w-11 h-6 bg-gray-200 rounded-full peer-checked:bg-[#540C0F] peer-focus:ring-0
                      after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 
                      after:border after:rounded-full after:h-5 after:w-5 after:transition-all
                      peer-checked:after:translate-x-full"
                  ></div>
                </label>
              </div>

            </div>

            <div className="col-span-12 md:col-span-6">

              {/* <div className="flex items-center gap-2">
                <span className="text-sm">We are Live</span>
                <label className="inline-flex items-center cursor-pointer ">
                  <input
                    type="checkbox"
                    checked={form.isThumbnailLive}
                    className="sr-only peer"
                    onChange={(e) => {
                      setForm({ ...form, isThumbnailLive: e.target.checked });
                    }}
                    disabled={!isAllow(`addLiveSettings`)}
                  />
                  <div
                    className="relative w-11 h-6 bg-gray-200 rounded-full peer-checked:bg-[#540C0F] peer-focus:ring-0
                      after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 
                      after:border after:rounded-full after:h-5 after:w-5 after:transition-all
                      peer-checked:after:translate-x-full"
                  ></div>
                </label>
              </div> */}
            </div>

            {/* Form Only Shows If Live = True */}
            {form.isLive && (
              <div className="grid grid-cols-12 gap-6">
                <div className="col-span-12">
                  <FormControl
                    type="text"
                    name="Button"
                    label="Button Name"
                    value={form.button}
                    onChange={(e) => setForm({ ...form, button: e })}
                    required
                  />
                  {submitted && !form.button && (
                    <p className="text-red-500 text-sm mt-1">
                      Button Name  is required.
                    </p>
                  )}
                </div>
                {/* Page Title */}
                <div className="col-span-12">
                  <FormControl
                    type="text"
                    name="title"
                    label="Page Title"
                    value={form.title}
                    onChange={(e) => setForm({ ...form, title: e })}
                    required
                  />
                  {submitted && !form.title && (
                    <p className="text-red-500 text-sm mt-1">
                      Title is required.
                    </p>
                  )}
                </div>

                {/* Subtitle */}
                <div className="col-span-12">
                  <FormControl
                    type="text"
                    name="subtitle"
                    label="Sub Title"
                    value={form.subtitle}
                    onChange={(e) => setForm({ ...form, subtitle: e })}
                    required
                  />
                  {submitted && !form.subtitle && (
                    <p className="text-red-500 text-sm mt-1">
                      Subtitle is required.
                    </p>
                  )}
                </div>

                {/* Page Header Text */}
                <div className="col-span-12">
                  <FormControl
                    type="text"
                    name="headerText"
                    label="Page Header Text"
                    value={form.headerText}
                    onChange={(e) => setForm({ ...form, headerText: e })}
                    required
                  />
                  {submitted && !form.headerText && (
                    <p className="text-red-500 text-sm mt-1">
                      Header text is required.
                    </p>
                  )}
                </div>
                <div className="col-span-12">
                  <FormControl
                    type="url"
                    name="headerLink"
                    label="Page Header Link (if url is not there the button will not visible)"
                    value={form?.headerLink}
                    onChange={(e) => setForm({ ...form, headerLink: e })}

                  />
                  {/* {submitted && !form.headerLink && (
                    <p className="text-red-500 text-sm mt-1">
                      Header Link is required.
                    </p>
                  )} */}
                </div>

                {/* Embed Code - Commented out as per requirement */}
                <div className="col-span-12">
                  <FormControl
                    type="textarea"
                    name="embedCode"
                    label="Embedded Code"
                    value={form.embedCode}
                    onChange={(e) => setForm({ ...form, embedCode: e })}
                  // required
                  />
                  {/* {submitted && !form.embedCode && (
                    <p className="text-red-500 text-sm mt-1">
                      Embedded code is required.
                    </p>
                  )} */}
                </div>

                {/* Video Upload */}
                <div className="col-span-12">
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Upload Video
                  </label>

                  {!form.video && (
                    <>
                      <label className="block cursor-pointer text-gray-500 bg-white border-2 border-dashed border-[#540C0F] rounded-lg text-sm px-4 py-4 text-center">
                        <input
                          type="file"
                          className="hidden"
                          accept="video/*"
                          onChange={uploadVideo}
                        />
                        <div className="flex flex-row gap-2 items-center justify-center">
                          <FiPlus className="text-2xl text-[#540C0F]" />
                          <span>Choose Video File</span>
                        </div>
                        <span className="text-[10px] text-gray-400">
                          MP4, WEBM, WMV, FLV, MKV (max 5 GB)
                        </span>
                      </label>

                      {progress > 0 && (
                        <div className="w-full bg-gray-200 rounded-full h-2.5 mt-4">
                          <div
                            className="bg-blue-600 h-2.5 rounded-full"
                            style={{ width: `${progress}%` }}
                          ></div>
                        </div>
                      )}
                    </>
                  )}

                  <div className="d-block mt-3">
                    {form.video && (
                        <LargeVideoPreview
                          key={form.video}
                          src={form.video}
                          onRemove={() => setForm((previous) => ({ ...previous, video: '' }))}
                        />
                    )}
                  </div>
                </div>

                {/* 🖼️ Image */}
                <div className="col-span-12 md:col-span-6">
                  <div>
                    <label className="">
                      Banner image — recommended size: 1600 × 900 px (16:9), minimum 1200 × 675 px.
                    </label>
                  </div>
                  <ImageUpload
                    model="users"
                    result={(e) => imageResult(e, "image")}
                    value={form.image}
                    label="Choose Image"
                  />
                </div>

                {/* 🖼️ Thumbnail */}
                <div className="col-span-12 md:col-span-6">
                  <div>
                    <label className="">
                      Thumbnail
                    </label>
                  </div>

                  <ImageUpload
                    model="users"
                    result={(e) => imageResult(e, "thumbnail")}
                    value={form.thumbnail}
                    label="Choose Thumbnail"
                    required={true}
                  />
                </div>



                <div className="col-span-12 ">
                  <div className="flex items-center justify-between gap-2 mb-4 border-b pb-3 border-gray-200">
                    <p className="text-xl font-semibold">Next Event Details</p>

                    {/* Toggle */}
                    <div className="flex items-center gap-2">
                      <span className="text-sm">Next Event?</span>
                      <label className="inline-flex items-center cursor-pointer ">
                        <input
                          type="checkbox"
                          checked={form.nextEvent}
                          className="sr-only peer"
                          onChange={(e) => {
                            setForm({ ...form, nextEvent: e.target.checked });
                          }}
                        />
                        <div
                          className="relative w-11 h-6 bg-gray-200 rounded-full peer-checked:bg-[#540C0F] peer-focus:ring-0
                      after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 
                      after:border after:rounded-full after:h-5 after:w-5 after:transition-all
                      peer-checked:after:translate-x-full"
                        ></div>
                      </label>
                    </div>
                  </div>
                </div>

                {form?.nextEvent ? <>
                  <div className="col-span-12 mt-[-3px]">
                    <FormControl
                      type="text"
                      name="headerLink"
                      label="Next event title"
                      value={form?.nextEventTitle}
                      onChange={(e) => setForm({ ...form, nextEventTitle: e })}
                      required
                    />
                    {submitted && !form?.nextEventTitle && (
                      <p className="text-red-500 text-sm mt-1">
                        Header Link is required.
                      </p>
                    )}
                  </div>
                  <div className="col-span-12 mt-[-3px]">
                    <FormControl
                      type="text"
                      name="headerLink"
                      label="Next event sub title"
                      value={form?.nextEventSubTitle}
                      onChange={(e) => setForm({ ...form, nextEventSubTitle: e })}
                      required
                    />
                  </div>

                  <div className="col-span-12 mt-[-3px]">
                    <FormControl
                      type="url"
                      name="nextEventurl"
                      label="Next event notify Url (if url is not there the button will not visible)"
                      value={form?.nextEventurl}
                      onChange={(e) => setForm({ ...form, nextEventurl: e })}
                    />
                  </div>
                </> : null}
                {/* Short Videos */}
                <div className="col-span-12">
                  <FormControl
                    type="multiselect"
                    name="shortVideos"
                    label="Select Short Videos"
                    value={form.selectedShortVideos}
                    onChange={(e) =>
                      setForm({ ...form, selectedShortVideos: e })
                    }
                    options={shortVideos}
                    theme="search"
                    isMulti={true}
                  />
                </div>

                {/* Live Sessions */}
                <div className="col-span-12">
                  <FormControl
                    type="multiselect"
                    name="liveSessions"
                    label="Select Live Sessions"
                    value={form.selectedLiveSessions}
                    onChange={(e) =>
                      setForm({ ...form, selectedLiveSessions: e })
                    }
                    options={liveSessions}
                    theme="search"
                    isMulti={true}
                  />
                </div>

                {/* Drag and Drop Reordering for Live Sessions */}
                {form.selectedLiveSessions && form.selectedLiveSessions.length > 0 && (
                  <div className="col-span-12">
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Reorder Live Sessions (Drag to change sequence)
                    </label>
                    <DndContext
                      sensors={sensors}
                      collisionDetection={closestCenter}
                      onDragEnd={handleDragEnd}
                    >
                      <SortableContext
                        items={form.selectedLiveSessions}
                        strategy={verticalListSortingStrategy}
                      >
                        <div className="space-y-2">
                          {form.selectedLiveSessions.map((sessionId, index) => {
                            const session = liveSessions.find((s) => s.id === sessionId);
                            return (
                              <SortableItem
                                key={sessionId}
                                id={sessionId}
                                index={index}
                                name={session?.name || "Unknown Session"}
                              />
                            );
                          })}
                        </div>
                      </SortableContext>
                    </DndContext>
                  </div>
                )}
              </div>
            )}

            {/* Buttons: Reset + Save */}
            <div className="text-right mt-6 flex items-center justify-end gap-3">
              <button
                type="submit"
                onClick={() => {
                  setForm({ ...form, guideTv: true });
                  setIsGuideTV(true);
                }}
                className="text-[#fff] border border-[#540C0F] font-medium rounded-lg text-sm px-5 py-2.5"
                disabled={!isAllow(`addLiveSettings`)}
              >
                Save as Guide TV
              </button>

              {/* RESET BUTTON */}
              <button
                type="button"
                onClick={handleReset}
                className="text-[#540C0F] border border-[#540C0F] font-medium rounded-lg text-sm px-5 py-2.5"
                disabled={!isAllow(`addLiveSettings`)}

              >
                Reset
              </button>

              {/* SAVE BUTTON */}
              <button
                type="submit"
                className="text-white bg-[#540C0F] focus:ring-4 font-medium rounded-lg text-sm px-5 py-2.5"
                disabled={!isAllow(`addLiveSettings`)}
              >
                Save
              </button>

            </div>

          </div>
        </div>
      </form>
    </Layout>
  );
};

// Sortable Item Component
const SortableItem = ({ id, index, name }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      className={`flex items-center gap-3 p-3 bg-white border border-gray-200 rounded-lg ${isDragging ? "shadow-lg" : "shadow-sm"
        }`}
    >
      <div
        {...attributes}
        {...listeners}
        className="cursor-grab active:cursor-grabbing text-gray-400 hover:text-gray-600"
      >
        <MdDragIndicator size={24} />
      </div>
      <div className="flex items-center gap-2 flex-1">
        <span className="flex items-center justify-center w-8 h-8 bg-[#540C0F] text-white rounded-full text-sm font-semibold">
          {index + 1}
        </span>
        <span className="text-gray-700 font-medium">{name}</span>
      </div>
    </div>
  );
};

export default LivePageSettings;
